import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreBottomSheet, {
    attrs: { "data-qa": "capture_type_list" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ xSpaceClass, counterXSpaceClass }) {
          return [
            _c(
              VList,
              { class: counterXSpaceClass },
              [
                _c(
                  VListItem,
                  {
                    staticClass: "py-1",
                    class: xSpaceClass,
                    attrs: {
                      "data-qa": "capture_type_list_item_photo_environment",
                    },
                    on: {
                      click: function ($event) {
                        return _setup.emit("choice-capture", "environment")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.t("Сделать фото", _setup.options)) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  VListItem,
                  {
                    staticClass: "py-1",
                    class: xSpaceClass,
                    attrs: { "data-qa": "capture_type_list_item_gallery" },
                    on: {
                      click: function ($event) {
                        return _setup.emit("choice-capture", false)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _setup.t("Загрузить из галереи", _setup.options)
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
    model: {
      value: _setup.isOpened,
      callback: function ($$v) {
        _setup.isOpened = $$v
      },
      expression: "isOpened",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }